import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { AppSidebarContainer } from '@/components/app/app-sidebar-container'
import { OrderMatchingNavigation } from '@/components/screens/order-line-matching/navigation'
import { OrderProjectsContainer } from '@/components/screens/order-line-matching/project-containers'
import { ErrorPanel } from '@/components/ui/error-panel'
import { useMe } from '@/providers/me-context'

export const Route = createFileRoute('/t/$tenant_id/order_line_matching/')({ component: Page })
function Page() {
  const { tenant_id: tenantId } = Route.useParams()
  const me = useMe()
  const navigate = useNavigate()
  return (
    <div className="flex min-h-screen bg-background">
      <AppSidebarContainer tenantId={tenantId} />
      <main className="min-w-0 flex-1 space-y-4 p-6">
        {me.tenant.setting?.orderLineMatchingEnabled === true && (
          <OrderMatchingNavigation tenantId={tenantId} value="projects" />
        )}
        {me.tenant.setting?.orderLineMatchingEnabled === true ? (
          <OrderProjectsContainer
            key={tenantId}
            onOpenProject={(projectKey) => {
              void navigate({
                to: '/t/$tenant_id/order_line_matching/projects/$project_key',
                params: { tenant_id: tenantId, project_key: projectKey },
              })
            }}
          />
        ) : (
          <ErrorPanel
            layout="section"
            title="発注明細照合機能が有効になっていません"
            description="ご利用を希望する場合は運営までお問い合わせください。"
          />
        )}
      </main>
    </div>
  )
}
